import { render } from "./modelcheckView.vue?vue&type=template&id=eb4ca3d6"
import script from "./modelcheckView.vue?vue&type=script&lang=js"
export * from "./modelcheckView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__